import { Spinner } from '@cian/ui-kit/loader';
import * as classNames from 'classnames';
import * as React from 'react';

import * as styles from './OfferItem.css';

export interface IOfferItemProps {
  url: string;
  photoUrl: string;
  price: string;
  features: React.ReactNode;
  underground: string | null;
  pending: boolean;

  onClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const OfferItem: React.FC<IOfferItemProps> = ({
  url,
  photoUrl,
  price,
  features,
  underground,
  pending,
  onClick,
}) => {
  return (
    <li className={classNames(styles['container'], pending && styles['pending'])}>
      <a className={styles['link']} href={url} onClick={onClick}>
        <div className={styles['image-container']}>
          <div className={styles['spinner']}>
            <Spinner size={16} color="gray20_100" />
          </div>
          {photoUrl && <img className={styles['image']} src={photoUrl} alt="" />}
        </div>
        <div className={classNames(styles['title'], styles['ellipsis'])}>{price}</div>
        {features}
        {/*<div className={classNames(styles['description'], styles['ellipsis'])}>{description}</div>*/}
        {underground && <div className={classNames(styles['underground'], styles['ellipsis'])}>{underground}</div>}
      </a>
    </li>
  );
};

OfferItem.displayName = 'OfferItem';
